import $ from 'jquery';
import 'selectize';
import 'selectize/dist/css/selectize.css';  // Import missing styles

export default () => {
    $('.selectize').each(function(k,v) {
        let $me = $(this),
            options = $me.data(),
            defaults = {};

        if (!! options.plugins) {
            options.plugins = options.plugins.split(',');
        }

        options = $.extend(defaults, options);

        $me.selectize(options);
    });
}
